module.exports = __webpack_public_path__ + "img/editar.e0d73f47.svg";